export abstract class CarFaxLocalStorage {
  constructor() {}

  static GetNonce = () => localStorage.getItem('am.carfax.auth.statenonce');
  static SetNonce = (nonce: string) => localStorage.setItem('am.carfax.auth.statenonce', nonce);

  static GetOriginalNonce = () => localStorage.getItem('am.carfax.auth.originalnonce');
  static SetOriginalNonce = (originalNonce: string) =>
    localStorage.setItem('am.carfax.auth.originalnonce', originalNonce);

  static GetAccessToken = () => localStorage.getItem('am.carfax.auth.access_token');
  static SetAccessToken = (token: string) =>
    localStorage.setItem('am.carfax.auth.access_token', token);

  static GetRefreshToken = () => localStorage.getItem('am.carfax.auth.refresh_token');
  static SetRefreshToken = (refreshToken: string) =>
    localStorage.setItem('am.carfax.auth.refresh_token', refreshToken);

  static GetUserName = () => localStorage.getItem('am.carfax.auth.userName');
  static SetUserName = (userName: string) =>
    localStorage.setItem('am.carfax.auth.userName', userName);

  static SetQueryParameterCode = (queryParameterCode: string) =>
    localStorage.setItem('am.carfax.queryparameter', queryParameterCode);

  static GetExpiresAt = () =>
    localStorage.getItem('am.carfax.auth.expires_at') !== null
      ? localStorage.getItem('am.carfax.auth.expires_at')
      : 0;

  // set the expiration date to the current time in milliseconds + (expires_in seconds * 1000 (to get milliseconds))
  static SetExpiresAt = (expiresInSeconds: number) =>
    localStorage.setItem(
      'am.carfax.auth.expires_at',
      (Date.now() + expiresInSeconds * 1000).toString(),
    );

  static GetRefreshExpiresAt = () =>
    localStorage.getItem('am.carfax.auth.refresh_expires_at') !== null
      ? localStorage.getItem('am.carfax.auth.refresh_expires_at')
      : 0;

  // set the refresh token expiration date to 29 days from now
  static ResetRefreshExpiresAt = () => {
    const refreshTokenExpirationDate = new Date();
    refreshTokenExpirationDate.setDate(refreshTokenExpirationDate.getDate() + 29);

    localStorage.setItem(
      'am.carfax.auth.refresh_expires_at',
      refreshTokenExpirationDate.getTime().toString(),
    );
  };

  static ValidateUser = (userName: string) => userName === CarFaxLocalStorage.GetUserName();

  static RenewToken = (tokenResponse: any) => {
    CarFaxLocalStorage.SetAccessToken(tokenResponse.access_token);
    CarFaxLocalStorage.SetRefreshToken(tokenResponse.refresh_token);
    CarFaxLocalStorage.SetExpiresAt(tokenResponse.expires_in);
    CarFaxLocalStorage.ResetRefreshExpiresAt();
  };

  static RemoveAll = () => {
    localStorage.removeItem('am.carfax.auth.statenonce');
    localStorage.removeItem('am.carfax.auth.originalnonce');
    localStorage.removeItem('am.carfax.auth.access_token');
    localStorage.removeItem('am.carfax.auth.refresh_token');
    localStorage.removeItem('am.carfax.auth.expires_at');
    localStorage.removeItem('am.carfax.auth.refresh_expires_at');
  };

  static IsLoggedIntoCarFax = () => CarFaxLocalStorage.IsRefreshTokenValid();

  static HasAccessToken = () => CarFaxLocalStorage.GetAccessToken() !== null;

  static IsAccessTokenValid = () => CarFaxLocalStorage.GetExpiresAt() > Date.now();

  static IsRefreshTokenValid = () => CarFaxLocalStorage.GetRefreshExpiresAt() > Date.now();
}
